const detalleSolicitudSRState = {
  loading: false,
  prestaciones: [],
  prestaciones2: [],
  prestaciones3: [],
  fechaSolicitud: null,
  tipoSolicitud: null,
  estadoSolicitud: null,
  fechaResolucion: null,
  loadingFile: false,
};

export default detalleSolicitudSRState;

